/**
 * Theme persistence. The toggle lives in the header; the stored preference is
 * applied once on app boot (in main.tsx) before React renders, to avoid a
 * flash of the wrong theme.
 */
export type Theme = 'light' | 'dark';

const STORAGE_KEY = 'polatkan-theme';

export function getStoredTheme(): Theme {
  if (typeof window === 'undefined') return 'light';
  return localStorage.getItem(STORAGE_KEY) === 'dark' ? 'dark' : 'light';
}

export function applyTheme(theme: Theme): void {
  document.documentElement.classList.toggle('dark', theme === 'dark');
}

export function setTheme(theme: Theme): void {
  localStorage.setItem(STORAGE_KEY, theme);
  applyTheme(theme);
}
